<template>
  <div class="grid grid-cols-2 items-center px-32 py-32 text-center">
    <div>
      <h1
        class="text-ontick-steel-900 pt-6 text-3xl font-bold dark:text-gray-300"
      >
        Vamos começar a investir?
      </h1>
      <p class="text-ontick-steel-500 py-3 text-sm dark:text-gray-400">
        Não encontramos nenhum investimento na sua conta. Acesse o marketplace
        para adicionar estratégias à sua conta.
      </p>
      <ontick-button
        @click.native="$router.push({ name: 'Marketplace' })"
        class="mt-4 w-full uppercase"
      >
        Acessar estratégias
      </ontick-button>
    </div>
    <div>
      <span v-html="not_historic"></span>
    </div>
  </div>
</template>

<script>
import { not_historic } from "../../../../assets/icons/isometric";

export default {
  data() {
    return {
      not_historic: not_historic,
    };
  },
};
</script>

<style></style>
